import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createTheme, ThemeProvider } from '@mui/material';
const theme = createTheme({
  palette: {
    primary: { main: "#0086FF" },
    secondary: { main: "#FF6100" },
    text: {
      primary: "#444444",
      secondary: "#1A1A1A",
    },
    icon: {
      primary: "#5F6368",
    },
    table: {
      headBackground: "#EDF7FF",
    },
  },
  typography: {
    fontSize: 14,
  },
  components: {
    MuiTypography: {
      defaultProps: {
        color: "text.primary",
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          fontSize: "14px",
          fontFamily: 'inherit'
        },
        head: {
          fontWeight: 500,
          background: "#EDF7FF"
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        outlined: {
          borderWidth: '2px',
          fontSize: '16px'
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          color: "primary",
        },
      },
    },
  },
});
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
